<template>
    <div class="quickOp">
        <vs-card style="min-height:600px;margin-bottom:80px">
            <vs-row>
                <vs-col class="w-1/2">
                    <h4 style="margin-left:10%">QuickOp</h4>
                    <!-- <p>{{opData}}</p> -->
                </vs-col>
                <vs-col class="w-1/2">
                    <div style="margin-left:90%;cursor:pointer;">
                        <feather-icon icon="XIcon" class="custom-class" title="close" @click="exit" ></feather-icon>
                    </div>
                </vs-col>
            </vs-row>
            <vs-divider></vs-divider>

            <div style="padding-left:4%;padding-right:4%">
                <vs-row>
                    <vs-col vs-lg="6">
                        <vs-row class="mb-2">
                            <vs-col vs-lg="3" class="topPad">
                                <span class="inputStyles">Op No</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/6 w-full">
                                <vs-input class="w-full" readonly  name="opNo" v-model="opData.opId" tabindex="-1" />
                            </vs-col>
                        </vs-row>

                        <vs-row class="mb-1">
                            <vs-col vs-lg="3" class="topPad">
                                <span class="inputStyles">Name</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/4 w-full">
                                <vs-input :disabled="readonlyFlag" v-validate="'required|alpha_spaces'" tabindex="1" type="text" name="patientname" v-model="opData.patientName" style="width:242px;"/>
                                <span class="text-danger text-sm" v-show="errors.has('patientname')">{{ errors.first('patientname') }}</span>
                            </vs-col>
                        </vs-row>
                         <vs-row class="mb-1">
                            <vs-col vs-lg="3" class="topPad">
                                <span class="inputStyles">Place</span>
                            </vs-col>
                            <vs-col vs-lg="4"  class="sm:w-1/4 w-full">
                                <vs-input  style="width:242px;" :disabled="readonlyFlag"  v-validate="'alpha_spaces'" tabindex="2"  type="text" name="place" v-model="opData.place"  />
                                <span class="text-danger text-sm" v-show="errors.has('place')">{{ errors.first('place') }}</span>
                            </vs-col>
                        </vs-row>

                        <vs-row class="mb-2">
                            <vs-col vs-lg="3" class="topPad">
                                <span class="inputStyles">Age</span>
                            </vs-col>
                            <vs-col vs-lg="3" class="sm:w-1/6 w-full">
                                <vs-input :disabled="readonlyFlag" class="w-full" v-validate="'required|numeric'" tabindex="3"  name="age" v-model="opData.age" />
                                <span class="text-danger text-sm" v-show="errors.has('age')">{{ errors.first('age') }}</span>
                            </vs-col>
                            <vs-col vs-lg="1" class="topPad">
                                <span class="inputStyles">Sex</span>
                            </vs-col>
                            <vs-col vs-lg="3" class="sm:w-1/5 w-full">
                                <select   :disabled="readonlyFlag" class=" vs-select--input myselect" tabindex="4"  v-model="opData.gender" style="height: 36px;width:96px" v-validate="'required'" name="gender">
                                    <option v-for="(item,index) in genderOption" v-bind:key="index" :value="item.genderCode" >{{item.GenderList}}</option>
                                </select>
                                <span class="text-danger text-sm" v-show="errors.has('gender')">{{ errors.first('gender') }}</span>
                            </vs-col>
                        </vs-row>

                        <vs-row class="mb-2">
                            <vs-col vs-lg="3" class="topPad">
                                <span class="inputStyles">Phone No</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/4 w-full">
                                <vs-input  style="width:242px;" :disabled="readonlyFlag" type="text" tabindex="5" :readonly="readonlyFlag" v-validate="'required|numeric|max:10|min:10'" name="phoneNo" v-model="opData.phoneNo" />
                                <span class="text-danger text-sm" v-show="errors.has('phoneNo')">{{ errors.first('phoneNo') }}</span>
                            </vs-col>
                        </vs-row>

                    </vs-col>


                    <vs-col vs-lg="6">
                        <vs-row class="mb-2">
                            <vs-col vs-lg="4" class="topPad">
                                <span class="inputStyles" style="padding-left:13%">Date</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/4 w-full">
                                <vs-input :disabled="readonlyFlag"  tabindex="-1"  v-model="opData.opDate" style="width:268px;" readonly  name="date" />
                                <!-- <flat-pickr :disabled="readonlyFlag" label="date" tabindex="-1"  v-model="opData.opDate" placeholder="select date"  style="width:268px;" @change="dateChange()" /> -->
                            </vs-col>
                        </vs-row>

                        <vs-row class="mb-2">
                            <vs-col vs-lg="4" class="topPad">
                                <span class="inputStyles" style="padding-left:13%">Doctor</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/4 w-full">
                                <select v-model="opData.doctorId" :disabled="readonlyFlag" tabindex="6" @change="ondoctorChange()" class=" vs-select--input myselect" style="height: 36px;width:268px" v-validate="'required'" name="doctor">
                                    <option v-for="(item,index) in doctorList" v-bind:key="index" :value="item.id" >{{item.name}}</option>
                                </select>
                                <!-- <v-select 
                                    label="doctorId"
                                    @input="ondoctorChange" 
                                    :options="$store.state.doctorlist"
                                    :value="$store.state.doctorlist.id"
                                ></v-select> -->
                                 <span class="text-danger text-sm" v-show="errors.has('doctor')">{{ errors.first('doctor') }}</span>
                            </vs-col>
                        </vs-row>

                        <vs-row class="mb-2">
                            <vs-col vs-lg="4" class="topPad">
                                <span class="inputStyles" style="padding-left:13%">Token No</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/6 w-full">
                                <vs-input :disabled="readonlyFlag" class="w-full" tabindex="7" readonly v-validate="'required|numeric'" name="tokenNo" v-model="opData.tokenNo" />
                                <span class="text-danger text-sm" v-show="errors.has('tokenNo')">{{ errors.first('tokenNo') }}</span>
                            </vs-col>
                            <vs-col vs-lg="1" class="topPad">
                                <span class="inputStyles">Time</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/4 w-full">
                                <vs-input :disabled="readonlyFlag" type="text" tabindex="8" readonly  v-validate="'required'" name="time"  v-model="opData.appointmentTime" style="width:122px;" />
                                <span class="text-danger text-sm" v-show="errors.has('time')">{{ errors.first('time') }}</span>
                            </vs-col>
                        </vs-row>

                        <vs-row class="mb-2">
                            <vs-col vs-lg="4" class="topPad">
                                <span class="inputStyles" style="padding-left:13%">DiscountCategory</span>
                            </vs-col>
                            <vs-col vs-lg="4" class="sm:w-1/3 w-full">
                                <select :disabled="readonlyFlag" v-model="opData.discountCategory" tabindex="9" class=" vs-select--input myselect" style="height: 36px;width:268px" v-validate="'required'" name="discountCategory" @change="discountperItem()">
                                    <option v-for="(item,index) in discountCategoryList" v-bind:key="index" :value="item.id" >{{item.name}}</option>
                                </select>
                                <span class="text-danger text-sm" v-show="errors.has('discountCategory')">{{ errors.first('discountCategory') }}</span>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>



                <vs-row class="topPad">
                    <vs-col vs-lg="12">
                        <table style="margin-left:13.5%;margin-right:8.5%">
                            <thead>
                                <th style="width:3%">SrNo</th>
                                <th style="width:35%">Description</th>
                                <th style="width:10%">Amount</th>
                                <th v-if="readonlyFlag==false" style="width:4%">&nbsp;</th>
                            </thead>
                            <tbody>
                                <tr v-for="(bill,index) in opData.billItems" v-bind:key="index">
                                    <td>
                                        <vs-input readonly="" class="configclass" tabindex="-1" v-model="bill.slNo"></vs-input>
                                    </td>
                                    <td>
                                        <select :disabled="readonlyFlag" v-model="bill.billItemId"  class=" vs-select--input myselect" style="height: 36px;" @change="getBillItemDetails(bill.billItemId,index)" >
                                            <option v-for="(item,index) in billDescriptionList" v-bind:key="index" :value="item.id" >{{item.name}}</option>
                                        </select>
                                    </td>
                                   
                                    <td>
                                        <vs-input :disabled="readonlyFlag"  class="configclass"  v-model="bill.totalAmount"  @keydown.tab="insertRow(index)" @change="showTotal()"/>
                                    </td>
                                    <td v-if="readonlyFlag==false">
                                        <feather-icon icon="Trash2Icon" class="mr-0 cursor-pointer" @click="deleteRow(index)"></feather-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </vs-col>
                </vs-row>
                <div style="margin-top:4%;">
                <vs-row class="topPad" >
                      <vs-col vs-lg="7">
                      </vs-col>
                         <vs-col vs-lg="5">
                        <vs-row class="mb-2" >
                            <vs-col vs-lg="4" class="topPad" style="margin-left:4%;">
                                <span class="inputStyles">Discount</span>
                            </vs-col>
                            <vs-col vs-lg="3" class="sm:w-1/2 w-full">
                                <vs-input  :disabled="readonlyFlag" style="width:89%;" @change="changeDiscount()"     name="discount" v-model="opData.totalDiscount" />
                            </vs-col>
                        </vs-row>
                        <vs-row class="mb-2">
                            <vs-col vs-lg="4" class="topPad" style="margin-left:4%;">
                                <span class="inputStyles">Total Amount</span>
                            </vs-col>
                            <vs-col vs-lg="2" class="sm:w-1/2 w-full">
                                <vs-input  style="width:89%;" readonly  name="total" v-model="opData.totalAmount"/>
                            </vs-col>
                        </vs-row> 
                        </vs-col>
                </vs-row>
                </div>
                <!-- btn grp -->
                <vs-row>
                    <vs-card class="footer">
                        <div class="btn-group" style="margin-left:77%;">
                            <vs-button :disabled="saveFlag" color="success" @click="saveOp" type="gradient" tabindex="-1">Save</vs-button>
                            <vs-button :disabled="printFlag" @click="printQuickOp" color="warning" type="gradient">Print</vs-button>
                            <!-- <vs-button   color="warning" type="gradient">Reset</vs-button> -->
                            <vs-button  color="danger" @click="exit" type="gradient">Exit</vs-button>
                        </div>
                    </vs-card>
                </vs-row>
            </div>
        </vs-card>
    <print-quick-op style="display:none" :opPrintData="opData"></print-quick-op>

    </div>
</template>
<script>
import printQuickOp from '../components/PrintQuickOp';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment';
export default {
    name:"quickOp",
    components: {
        flatPickr,printQuickOp
    },
    data(){
        return{
            opData:{
            companyId: this.$session.get('companyId'),
            opId:'New',
            // opDate:new Date().toISOString().slice(0, 10),
            opDate:'',
            doctorId:0,
            doctorName:"",
            tokenNo: "",
            gender:'',
            age:'',
            place:'',
            patientName:"",
            discountCategory:0,
            phoneNo: "",
            tokenBookingId:"",
            appointmentTime: "",
            totalAmount:0,
            totalDiscount:0,
            billItems: [{
                    "slNo": 1,
                    "billItemId": 0,
                    "billItem": "",
                    "billAmount": "",
                    "discountAmount":0,
                    "totalAmount":""
                }],
            },
            discountCategoryList:[{
                 "id": 0,
                "name": "select"
            }
            ],

            // doctorList:[],
            doctorList:[{
                "id":0,
                "name":"select"
            }],
            billDescriptionList:[{
                "id":0,
                "name":"select"
            }],
        //    billDescriptionList:this.$store.state.billItems,
            genderOption: [{
                    genderCode: "",
                    GenderList: "Select",
                }, {
                    genderCode: "Female",
                    GenderList: "Female",
                },
                {
                    genderCode: "Male",
                    GenderList: "Male",
                },
                {
                    genderCode: "Other",
                    GenderList: "Other",
                }
            ],
            readonlyFlag:false,
          
            printFlag:true,totalDiscount:"",saveFlag:false
        }
    },
    beforeMount(){
        let date = new Date().toISOString().slice(0, 10);
        var newDate =[];
        newDate = date.split('-');
        this.opData.opDate = newDate[2]+'-'+newDate[1]+'-'+newDate[0];
    },
   
    mounted() {
        // this.doctorList=this.$store.state.doctorList,
      
        this.getDoctorList();
        this.getBillItems();
        this.getDiscountCategory();
          if (this.$route.query.tokenId) {
            this.opData.tokenBookingId = parseInt(this.$route.query.tokenId);
            this.getTokenDetails();
            this.readonlyFlag = true;
        }
        if (this.$route.query.opId) {
            this.opData.opId = parseInt(this.$route.query.opId);
            this.getQuickOpDetails();
            this.readonlyFlag = true;
        }

        

    },
    methods:{
        // dateChange(){
        // flatpickr("#opDate", { 
        //     "dateFormat":"d-m-Y", 
        //   });
        // },
        ondoctorChange(){
             this.doctorList.forEach((value) => {
                 if(value.id==this.opData.doctorId){
                     this.opData.doctorName=value.name;
                 }
             });
             this.getNextTokenDetails();
        },
        getDoctorList() {
            var request = {
                companyId: this.$session.get('companyId')
            };
            this.$http.post(
                    "getdoctorlist",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    response.data.data.forEach((value) => {
                        this.doctorList.push(value);
                    })
                });
        },
         getBillItems() {
            var request = {
                companyId: this.$session.get('companyId')
            };
            this.$http.post(
                    "v2/getbillitems",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    response.data.data.forEach((value) => {
                        this.billDescriptionList.push(value);
                    })
                });
        },
        deleteRow(deleteRowIndex) {
            if (deleteRowIndex > 0) {
                this.$delete(this.opData.billItems, deleteRowIndex);
                this.showTotal();
            }

        },
        insertRow(index) {
            if (this.opData.billItems.length == (index + 1)) {
                var newrow = {
                    "slNo": this.opData.billItems.length + 1,
                    "billItemId": 0,
                    "billAmount":"",
                    "discountAmount":0,
                    "totalAmount":""
                }
                this.opData.billItems.push(newrow)
            }
        },
        getNextTokenDetails(){
          var request = {
                companyId: this.$session.get('companyId'),
                doctorId: this.opData.doctorId
            };
            this.$http.post(
                    "/getNextAvailableToken",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    // var tokenTime = response.data.data.tokenTime.split(' ');
                    this.opData.appointmentTime = response.data.data.tokenTime;
                    this.opData.tokenNo = response.data.data.tokenNo;
                });
        },
       getTokenDetails() {
            var request = {
                companyId: this.$session.get('companyId'),
                tokenId: this.opData.tokenBookingId
            };
            this.$http.post(
                    "v2/gettokendetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    var appDate =  response.data.data.appointmentDate;
                    var appTime = response.data.data.appointmentTime;
                    
                    this.opData.doctorId = response.data.data.doctorId;
                    this.opData.appointmentTime = appDate +" "+ appTime;
                    this.opData.phoneNo = response.data.data.bookedNo;
                    this.opData.tokenNo = response.data.data.tokenNo;
                });
        },
        getQuickOpDetails(){
               var request = {
                companyId: this.$session.get('companyId'),
                opNo: this.opData.opId
            };
            this.$http.post(
                    "/getQuickOpdetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    this.readonlyFlag=true;
                    this.saveFlag=true;
                    this.printFlag=false;
                    this.opData.opId = response.data.data.opId;
                    this.opData.patientName = response.data.data.patientName;
                    this.opData.place = response.data.data.place;
                    this.opData.age = response.data.data.age;
                    this.opData.gender = response.data.data.gender;
                    this.opData.opDate = moment(response.data.data.opDate).format('DD-MM-YYYY');
                    // var opDate = [];
                    // opDate = (response.data.data.opDate).split('-');
                    // this.opData.opDate = opDate[2]+'-'+opDate[1]+'-'+opDate[0];
                    // alert(this.opData.opDate );
                    this.opData.doctorId = response.data.data.doctorId;
                    this.opData.appointmentTime = response.data.data.appointmentTime;
                    this.opData.phoneNo = response.data.data.phoneNo;
                    this.opData.tokenNo = response.data.data.tokenNo;
                    this.opData.discountCategory = response.data.data.discountCategory;
                    
                    this.doctorList.forEach((value) => {
                        if(value.id==this.opData.doctorId){
                            this.opData.doctorName=value.name;
                        }
                    });

                    response.data.data.billItems.forEach((value) => {
                        value.totalAmount = value.billAmount - value.discountAmount;
                        // response.data.data.billItems.push(value.totalAmount);
                    });
                    this.opData.billItems = response.data.data.billItems;
                    this.opData.totalDiscount = response.data.data.totalDiscount;
                    this.opData.totalAmount=response.data.data.totalAmount;
                    this.$store.dispatch('updateSavedOpData', this.opData);
                });
        },
        getDiscountCategory() {
            var request = {
                companyId: this.$session.get('companyId')
            };
            this.$http.post(
                    "getDiscountCategory",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    response.data.data.forEach((value) => {
                        this.discountCategoryList.push(value);
                    })

                });
        },
        saveOp(){
             this.$validator.validateAll().then(valid => {
                 if(valid){
                     console.log(JSON.stringify(this.opData));
                    //  var opdata=this.$store.state.opList;
                    //  this.printFlag=false;
                    //  opdata.push({opNo:"1",opDate:this.opData.opDate,patientId:"1",patientName:this.opData.patientName,"patientPhoneNo":this.opData.phoneNo,doctorName:"Dr Sameer Ahammad"}) 
                    //  this.$store.dispatch('updateOpDashbaord', opdata);  
                    //  this.$store.dispatch('updateSavedOpData', this.opData);                             
                    //      this.$vs.notify({
                    //             title: 'Saved Successfully',
                    //             color: 'success',
                    //             iconPack: 'feather',
                    //             icon: 'icon-check',
                    //             position: 'top-center'
                    //         });
                            //   this.printQuickOp();

                
                    this.$http.post(
                            "saveQuickOp",
                            JSON.stringify(this.opData), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            this.printFlag = false;
                            this.opData.opId = response.data.data.opId;
                            this.$store.dispatch('updateSavedOpData', this.opData);   
                            this.$vs.notify({
                                title: 'Saved Successfully',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            });

                        });

                 }
             });
        },
        exit(){
            this.$router.go(-1);
        },
     getBillItemDetails(billItemId, index) {
                var request = {
                    companyId: this.$session.get('companyId'),
                    itemId: billItemId
                };
                this.$http.post(
                        "v2/getbillitemdetails",
                        JSON.stringify(request), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    .then(response => {
                        var mydata = response.data.data;
                        this.opData.billItems[index].billAmount = mydata.price;
                        this.opData.billItems[index].billItem = mydata.billItem;
                        this.opData.billItems[index].totalAmount = mydata.price;
                        // this.showTotal();
                            this.discountperItem();
                    }).catch(error => {
                       this.opData.billItems[index].billAmount = null;
                       this.opData.billItems[index].billItem  = null;
                       this.opData.billItems[index].totalAmount = null;
                        // this.showTotal();
                         this.discountperItem();
                    })
        },
        showTotal(){
            // this.discountperItem()
            this.opData.totalDiscount = 0;
            this.opData.totalAmount = 0;
            this.opData.billItems.forEach((value) => {
                if(value.totalAmount > value.billAmount){
                    value.billAmount = value.totalAmount;
                }else{
                    value.billAmount = value.totalAmount;
                }
                this.opData.totalAmount=(this.opData.totalAmount *1)+(1*value.totalAmount);
                this.opData.totalDiscount=(1*this.opData.totalDiscount)+(1*value.discountAmount);
            })
            
       },
       discountperItem(){
           var curDiscount=0;
           if(this.opData.discountCategory != 0){
               this.discountCategoryList.forEach(element => {
                  if(element.id ==this.opData.discountCategory) {
                     curDiscount = parseInt(element.discountPercentage);
                  }
               });
           
           this.opData.billItems.forEach((value) => {
               value.discountAmount = (value.billAmount * curDiscount / 100);
               console.log("hi=",value.billAmount);
               value.totalAmount=value.billAmount-value.discountAmount;
           });
           }else{
               console.log('discount');
           }
            this.showTotal();
       },
       onDiscountChange(index){
            var discountValue = this.opData.billItems[index].discountAmount;
            this.opData.totalDiscount = 0;
            this.opData.totalAmount = 0;
            this.opData.billItems[index].totalAmount = (this.opData.billItems[index].billAmount - discountValue)
            this.opData.billItems.forEach((value) => {
                if(value.discountAmount){
                this.opData.totalDiscount= this.opData.totalDiscount+ parseInt(value.discountAmount) ;
                }else{
                    this.opData.totalDiscount=0;
                }
                if(value.billAmount){
                this.opData.totalAmount= this.opData.totalAmount+parseInt(value.billAmount);
                }else{
                    this.opData.totalAmount=0;
                }
            }) ;
       },
       changeDiscount(){
           alert(this.opData.totalAmount);
           alert(this.opData.totalDiscount);
           this.opData.totalAmount = this.opData.totalAmount -  this.opData.totalDiscount;
       },
       printQuickOp(){
           this.$htmlToPaper('printQuickOp');
       },

}
}
</script>
<style>
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
.configclass {
    width: -webkit-fill-available;
}
.footer {
    position: fixed;
    left: 0;
    bottom: -20px;
    width: 100%;
    z-index: 500;
}

table {
    border-collapse: collapse;
}

table th {
    text-align: center;

}

table thead {
    background: #eaeff3;
}
</style>
